import { Box, Divider, Grid, Typography } from "@mui/material";
import ClientCard from "components/ui/ClientFlow/ClientCard";
import OrderPage from "features/clients/quote_order_page/Order/OrderPage";
import QuotePage from "features/clients/quote_order_page/Quote/QuotePage";
import React from "react";

function QuotesOrdersPage() {
  return (
    <div style={{ marginTop: "-8px", maxHeight: "75vh", overflow: "auto", overflowX: "hidden", scrollbarWidth: "none", marginLeft: "6px" }}>
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "start", gap: "12px" }}>
        <Typography sx={{ fontFamily: "poppins", fontWeight: "500", fontSize: "20px" }}>Quotes</Typography>
        <QuotePage />
      </div>

      <Divider sx={{ margin: "1.5rem -2rem", height: "4px", background: "#0D0D0D", border: "none" }} />

      <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "start", gap: "12px" }}>
        <Typography sx={{ fontFamily: "poppins", fontWeight: "500", fontSize: "20px" }}>Orders</Typography>
        <OrderPage />
      </div>
    </div>
  );
}

export default QuotesOrdersPage;
